import Service from "../../services/SubscriptionClassesService";
import RequestList from "../../services/RequestList";

const state = {
    items : [],
    fetching : false
}


const mutations = {
    SET_ITEMS(state, items) {
        state.items = items;

    },
    SET_FETCHING(state, value) {
        state.fetching = value;
    }
}

const actions = {
    async fetch({ commit }) {

        commit('SET_FETCHING', true);

        try {
            let requestList = new RequestList();

            let {
                data
            } = await Service.list(requestList);
            commit('SET_FETCHING', false);

            commit('SET_ITEMS', data.value.subscription_classes);
        } finally {
            commit('SET_FETCHING', false);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}